import * as React from 'react';
import { Button, Typography } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { WidgetInputType } from 'common/schema/widget/input/WidgetInputType';
const { Text, Paragraph } = Typography;

export interface WidgetInputUploadDraggerTextProps {
  widgetType?: WidgetInputType;
  description?: string;
  hint?: React.ReactNode;
}

export function WidgetInputUploadDraggerText(
  props: WidgetInputUploadDraggerTextProps
) {
  const { hint, description, widgetType } = props;
  const text =
    widgetType == WidgetInputType.UploadSigned
      ? `Fai click o trascina un file in quest'area per caricare il modulo firmato.`
      : `Fai click o trascina un file in quest'area per caricare gli allegati.`;

  return (
    <>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">
        {description?.length && description?.length > 1 ? description : text}
      </p>
      {hint && <p className="ant-upload-hint">{hint}</p>}
    </>
  );
}
